export const storeName = 'NAVIGATION';

export default {
    GET_NAVIGATION_CATEGORY_TAGS: `${storeName}.GET_NAVIGATION_CATEGORY_TAGS`,
    SET_NAVIGATION_CATEGORY_TAGS: `${storeName}.SET_NAVIGATION_CATEGORY_TAGS`,
    CLEAR_NAVIGATION_CATEGORY_TAGS: `${storeName}.CLEAR_NAVIGATION_CATEGORY_TAGS`,
    SET_NAVIGATION_CATEGORY_ENDPOINT: `${storeName}.SET_NAVIGATION_CATEGORY_ENDPOINT`,
    FETCH_RELATED_KEYWORDS: `${storeName}.FETCH_RELATED_KEYWORDS`,
    SET_RELATED_KEYWORDS: `${storeName}.SET_RELATED_KEYWORDS`,
    GET_CATEGORY_PAGE_TAGS: `${storeName}.GET_CATEGORY_PAGE_TAGS`,
    GET_PRODUCT_LIST: `${storeName}.GET_PRODUCT_LIST`,
    SET_PRODUCT_LIST: `${storeName}.SET_PRODUCT_LIST`,
    GET_NEXT_PAGE: `${storeName}.GET_NEXT_PAGE`,
    SET_CURRENT_PAGE: `${storeName}.SET_CURRENT_PAGE`,
    SET_INTEREST_SELECTION_COMPONENTS: `${storeName}.SET_INTEREST_SELECTION_COMPONENTS`,
    SET_INTEREST_SELECTION_COMPONENT_DATA: `${storeName}.SET_INTEREST_SELECTION_COMPONENT_DATA`,
    GET_INTEREST_SELECTION_POPUP_CONTENT: `${storeName}.GET_INTEREST_SELECTION_POPUP_CONTENT`,
    SET_INTEREST_SELECTION_KEYWORDS: `${storeName}.SET_INTEREST_SELECTION_KEYWORDS`,
    INTEREST_SELECTION_STEP_SUBMIT: `${storeName}.INTEREST_SELECTION_STEP_SUBMIT`,
};
